// ENUMS ##########################################################
export enum IndicateElsterFieldPositionEnum {
	AFTER = 'after',
	BEFORE = 'before'
}

export enum IndicateElsterFieldContextEnum {
	DEFAULT = 'default',
	FORM = 'form',
}

// DECLARATIONS ###################################################


// INTERFACES #####################################################


// TYPES ##########################################################


// CLASSES ########################################################
